// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-button] {\n  text-decoration: none !important;\n}\n[data-button] > .external_link_icon {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
